import { useQuery } from "@tanstack/react-query";

export interface DepthRung {
  label: string;
  bps: number;
  cumulative_quote: number | null;
  incremental_quote: number | null;
  measurable: boolean;
}
export interface LiveProfile {
  venue: string;
  pair: string;
  anchor_ts: string | null;
  anchor_age_seconds: number | null;
  best_bid: number | null;
  best_ask: number | null;
  mid: number | null;
  bid_rungs: DepthRung[];
  ask_rungs: DepthRung[];
  ladder_bps: number[];
  status: string;
  profile_source?: string | null;
  notional_unit?: string | null;
  eth_usd?: number | null;
}

async function fetchLiveProfile(venue: string, pair: string): Promise<LiveProfile> {
  const qs = new URLSearchParams({ venue, pair });
  const res = await fetch(`/api/v1/book-l2-depth/live-profile?${qs.toString()}`, {
    headers: { Accept: "application/json" },
  });
  if (!res.ok) throw new Error(`live-profile ${res.status}`);
  return (await res.json()) as LiveProfile;
}

// reconstructed live; poll a touch faster than the 5m card since it's "now"
const POLL_MS = 15_000;

export function useLiveProfile(venue: string, pair: string) {
  return useQuery({
    queryKey: ["live-profile", venue, pair],
    queryFn: () => fetchLiveProfile(venue, pair),
    refetchInterval: POLL_MS,
    staleTime: POLL_MS,
  });
}
